import { Button } from '@mui/material';
import { styled } from '@mui/styles';

export const SingleButtonStyled = styled(Button)(({
  theme, bgColor, hoverColor,
  radius = '100px', btnWidth = 115, variant, textColor, borderColor,
}) => {
  let customProperties = {};
  if (variant === 'contained') {
    customProperties = {
      backgroundColor: bgColor,
      color: theme.palette.getContrastText(bgColor),
    };
  }

  return {
    ...customProperties,
    borderRadius: radius,
    textTransform: 'none',
    color: textColor,
    borderColor,
    width: btnWidth,
    '&:hover': {
      backgroundColor: hoverColor,
      borderColor,
    },
  };
});
